// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
Vue.use(Treeselect);

/* eslint-disable no-new */
new Vue({
  el: '#newsWrap',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js